import { getObjects, createObject, updateObject, deleteObject, exportObjects, exportFile_Bilan } from "../../../services/services";
import Conditions from "../../../assets/files/conditions.json";

const combboxElements = [
  { label: "Element A 1001", value: 1 },
  { label: "Element B 1002", value: 2 },
];
export const Change_requestsConfig = {
  title: "Change_requests",
  entityLabel: "Change_request",

  idField: "id",
  
  rowActions: [
    { key: "info", label: "Info", permission: "view_changeRequests", action: "info" },
    { key: "edit", label: "Edit", permission: "add_change_request", action: "edit" },
    { key: "delete", label: "Delete", permission: "delete_change_request", action: "delete" }
  ],

  actionHandlers: {
    info: ({ entity, setState, setFormParams }) => {
    setState("info");
    setFormParams([entity]);
    },
    edit: ({ entity, setState, setFormParams }) => {
      setState("edit");
      setFormParams([entity]);
    },
    delete: async ({ entity, setEntityToDelete }) => {
      setEntityToDelete(entity);
    },
  },
  services: {
    list: getObjects,
    create: createObject,
    update: updateObject,
    delete: deleteObject,
    export: exportObjects,
    export_bilan: exportFile_Bilan,
    filters: "show",
    columns: "show",

    services_url_names: {
    list: "get_Change_Requests",
    create: "create_change_request",
    update: "update_change_request",
    delete: "delete_change_request",
    export: "export_Change_Requests",
    export_bilan: "export_change_requests_bilan",
    },
  },

  attributes: [
    { label: "id", value: "id", type: "int", is_default:"true" },
    { label: "element_id", value: "element_id", type: "int", is_default:"true" },
    { label: "element__pbscode", value: "element__pbscode", type: "str" },
    { label: "change_request_code", value: "change_request_code", type: "str", is_default:"true" },
    { label: "flag", value: "flag", type: "str", is_default:"true" },
    { label: "created_at", value: "created_at", type: "date" },
    { label: "updated_at", value: "updated_at", type: "date" }, 
  ],
  conditions: Conditions,

  formFields: [
    { key: 'element_id', label: 'element_id', type: 'Autocomplete', Autocomplete:combboxElements, placeholder:'Select PBS element', validation: 'required' },
    { key: "change_request_code", label: "change_request_code",type: 'input' },
    { key: "flag", label: "flag",type: 'input' },
  ],

   defaultFilters : [],


  // =========================
  // TABS CONFIG (CUSTOM PER ENTITY)
  // =========================
  tabs: [
    {
      label: "All",
      filters: [],   // tabIndex 0
    },
    {
      label: "HFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.1',type:'str'}],   // tabIndex 1
     
    },
    {
      label: "LFI",
      filters: [{attribute:'pbscode',condition:'start',value:'1.2',type:'str'}],   // tabIndex 2
       
    },
  ],
};
